
import React from "react";
import { Link } from "react-router-dom";
import HeroSection from "@/components/sections/HeroSection";
import DuduSection from "@/components/sections/DuduSection";
import AboutSection from "@/components/sections/AboutSection";
import FeaturesSection from "@/components/sections/FeaturesSection";
import ModulesSection from "@/components/sections/ModulesSection";
import AudienceSection from "@/components/sections/AudienceSection";
import PricesSection from "@/components/sections/PricesSection";
import FaqSection from "@/components/sections/FaqSection";
import CtaSection from "@/components/sections/CtaSection";
import useScrollReveal from "@/hooks/useScrollReveal";

const Index = () => {
  useScrollReveal();
  
  return (
    <div className="min-h-screen bg-black text-white">
      <HeroSection />
      
      <div className="section-divider" />
      <AboutSection />
      
      {/* Community Spirit Section */}
      <section className="py-16 px-6 md:px-10 max-w-6xl mx-auto">
        <div className="scroll-reveal">
          <div className="relative rounded-lg overflow-hidden">
            <img
              src="/lovable-uploads/f0d01beb-037c-4e28-8a13-21af8facb412.png"
              alt="Escape Club Community"
              className="w-full h-[400px] md:h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
            <div className="absolute bottom-8 left-8 right-8 text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Faça Parte da Comunidade
              </h3>
              <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
                Junte-se a pessoas que, como você, decidiram escapar do óbvio e construir uma vida extraordinária.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <div className="section-divider" />
      <FeaturesSection />
      
      {/* New Image Section - Back-facing with Escape shirt */}
      <section className="py-16 px-6 md:px-10 max-w-6xl mx-auto">
        <div className="scroll-reveal">
          <div className="text-center">
            <img
              src="/lovable-uploads/1b7a208f-046c-4bac-8854-ec70bb2349a5.png"
              alt="Dudu de costas com camiseta Escape"
              className="w-full max-w-2xl mx-auto rounded-lg shadow-lg"
            />
            <div className="mt-8">
              <p className="text-2xl md:text-3xl font-bold text-white italic">
                "O comum morre aqui."
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <div className="section-divider" />
      <ModulesSection />
      
      <div className="section-divider" />
      <AudienceSection />
      
      <div className="section-divider" />
      <PricesSection />
      
      <div className="section-divider" />
      <DuduSection />
      
      <div className="section-divider" />
      <FaqSection />
      
      <div className="section-divider" />
      <CtaSection />
      
      <footer className="py-8 text-center text-sm opacity-50">
        <p>© {new Date().getFullYear()} ESCAPE CLUB. Todos os direitos reservados.</p>
        <div className="mt-4">
          <Link to="/escape21" className="text-green-400 hover:underline">
            Conheça o ESCAPE21 - Desafio Gratuito de 21 Dias
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Index;
